import React, {useState} from "react";
import {Card, FloatingLabel, Form, Modal} from "react-bootstrap";
import {Job} from "../models/job";
import jobApis from "../api/jobApis";
import {compareJobs} from "../functions";

interface WorkedHoursNewJobModalProps {
    readonly show: boolean
    readonly setShow: React.Dispatch<React.SetStateAction<boolean>>
    readonly selectJob: (job: Job) => void
    readonly smaller?: boolean
}

function WorkedHoursNewJobModal(props: WorkedHoursNewJobModalProps) {
    const [searchText, setSearchText] = useState("");
    const [jobs, setJobs] = useState<Job[]>([]);

    const searchTextLabel = props.smaller ?
        "Cerca per commessa, oggetto o cliente" : "Cerca per numero di commessa, oggetto o cliente";

    function getJobs() {
        jobApis.getActiveJobs()
            .then(jobs => setJobs(jobs))
            .catch(err => console.error(err))
    }

    function handleSubmit(job: Job) {
        props.selectJob(job);
        props.setShow(false);
    }

    return (
        <Modal className="modal-fixed-height" size="lg" show={props.show} onShow={getJobs}
               onHide={() => props.setShow(false)} onExited={() => setSearchText("")}>
            <Modal.Header closeButton>
                <Modal.Title>Seleziona una nuova commessa</Modal.Title>
            </Modal.Header>
            <Modal.Header>
                <Form className="w-100">
                    <FloatingLabel controlId="floatingInput" label={searchTextLabel} className="mb-3">
                        <Form.Control type="search" value={searchText}
                                      onChange={ev => setSearchText(ev.target.value)}
                                      placeholder={searchTextLabel}/>
                    </FloatingLabel>
                </Form>
            </Modal.Header>
            <Modal.Body className="modal-body-overflow">
                {jobs.sort(compareJobs)
                    .filter(job => {
                        const searchString = searchText.toLowerCase();

                        return searchText === "" ||
                            job.id.toLowerCase().startsWith(searchString) ||
                            job.subject.toLowerCase().includes(searchString) ||
                            job.client.toLowerCase().includes(searchString);
                    })
                    .map(job => <JobListItem key={job.id} job={job} selectJob={handleSubmit}/>)}
            </Modal.Body>
        </Modal>
    );
}

interface JobListItemProps {
    readonly job: Job
    readonly selectJob: (job: Job) => void
}

function JobListItem(props: JobListItemProps) {

    return (
        <Card key={props.job.id} className="job-card mb-3" onClick={() => props.selectJob(props.job)}>
            <Card.Body className="px-3 py-1">
                <p className="p-mt grey">{props.job.id} {props.job.inProgress && <em>(in lavorazione)</em>}</p>
                <p className="p-mt"><strong>{props.job.client}</strong> - {props.job.subject}</p>
            </Card.Body>
        </Card>
    );
}

export default WorkedHoursNewJobModal;